<template>
    <div
	v-if="$store.state.dataList.length != 0 && $store.state.show"
	class="footer-bg">
        <ul class="footer-list">
            <li
            v-for="(item, index) in list"
            :key="index">
                <el-link
                :href="item.url"
                target="_blank"
                :underline="false">{{item.name}}</el-link>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
            list: [
                {
                    name: '关于我们',
                    url: '/Index/Wjsproviders.html'
                },
                {
                    name: '联系我们',
                    url: '/about/contactus.html'
                },
                {
                    name: '发展历程',
                    url: '/zt/zxdsj/'
                },
                {
                    name: '产品服务',
                    url: '/Index/Wjsproviders.html'
                },
                {
                    name: '网经社 版权所有',
                    url: '/'
                },
            ]
        }
    }
}
</script>

<style scoped>
.footer-bg {
    width: 100%;
    background: #222;
    padding: 30px 0 10px 0;
}

.footer-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 1100px;
    margin: auto;
    border-bottom: #313131 solid 1px;
}

.footer-list li:last-child {
    flex: 0 0 100%;
}

.footer-list .el-link {
    position: relative;
    padding: 10px 20px;
}

.footer-list .el-link:hover {
    color: #fff;
}

.footer-list .el-link::after {
    content: '丨';
    color: #666;
    position: absolute;
    right: -6px;
}

.footer-list li:last-child {
    text-align: center;
}

.footer-list li:nth-child(4) .el-link::after,
.footer-list li:last-child .el-link::after {
    content: ''
}

@media(max-width: 1100px) {
    .footer-list .el-link {
        padding: 10px;
    }
}
</style>
